var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6227 12.7131H18.1473C17.5622 12.7131 17.0879 13.1875 17.0879 13.7726V26.4857C17.0879 27.0708 17.5622 27.5451 18.1473 27.5451H26.6227C27.2079 27.5451 27.6822 27.0708 27.6822 26.4857V13.7726C27.6822 13.1875 27.2079 12.7131 26.6227 12.7131Z",
    stroke: "white",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6227 1.23608H18.1473C17.5622 1.23608 17.0879 1.71041 17.0879 2.29551V6.55442C17.0879 7.13952 17.5622 7.61384 18.1473 7.61384H26.6227C27.2079 7.61384 27.6822 7.13952 27.6822 6.55442V2.29551C27.6822 1.71041 27.2079 1.23608 26.6227 1.23608Z",
    stroke: "white",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1442 1.23596H3.6688C3.0837 1.23596 2.60938 1.71028 2.60938 2.29539V15.0085C2.60938 15.5936 3.0837 16.068 3.6688 16.068H12.1442C12.7293 16.068 13.2037 15.5936 13.2037 15.0085V2.29539C13.2037 1.71028 12.7293 1.23596 12.1442 1.23596Z",
    stroke: "white",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1442 21.1672H3.6688C3.0837 21.1672 2.60938 21.6415 2.60938 22.2266V26.4855C2.60938 27.0706 3.0837 27.5449 3.6688 27.5449H12.1442C12.7293 27.5449 13.2037 27.0706 13.2037 26.4855V22.2266C13.2037 21.6415 12.7293 21.1672 12.1442 21.1672Z",
    stroke: "white",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconLight);
export default __webpack_public_path__ + "static/media/DashboardIconLight.16adddcc8c9ab59b406f899ff5ad78ff.svg";
export { ForwardRef as ReactComponent };